import {
    record as rrwebRecord,
    wasMaxDepthReached,
    resetMaxDepthState,
    getLastSnapshotCost,
    getMutationCost,
    getDeferredStylesheetStats,
    getDiscardedDurationSamples,
    resetSnapshotCostState,
} from '@posthog/rrweb-record'
import { getRecordConsolePlugin } from '@posthog/rrweb-plugin-console-record'
import { assignableWindow } from '../utils/globals'
import { getRecordNetworkPlugin } from '../extensions/replay/external/network-plugin'
import { LazyLoadedSessionRecording } from '../extensions/replay/external/lazy-loaded-session-recorder'

assignableWindow.__PosthogExtensions__ = assignableWindow.__PosthogExtensions__ || {}
assignableWindow.__PosthogExtensions__.rrwebPlugins = { getRecordConsolePlugin, getRecordNetworkPlugin }
assignableWindow.__PosthogExtensions__.rrweb = {
    record: rrwebRecord,
    version: 'v2',
    wasMaxDepthReached,
    resetMaxDepthState,
    getLastSnapshotCost,
    getMutationCost,
    getDeferredStylesheetStats,
    getDiscardedDurationSamples,
    resetSnapshotCostState,
}
assignableWindow.__PosthogExtensions__.initSessionRecording = (ph, documentWasEverVisible) =>
    new LazyLoadedSessionRecording(ph, documentWasEverVisible)

export default rrwebRecord
